import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppShell } from "../components/layout/AppShell";
import { myRequests } from "../api/hr";
import { ResignationForm } from "../features/hr/ResignationForm";
import { RequestStatusList } from "../features/hr/RequestStatusList";

export default function ResignationPage() {
  const { t } = useTranslation();
  const [resignations, setResignations] = useState([]);

  const load = async () => {
    const d = await myRequests();
    setResignations(d.resignations || []);
  };
  useEffect(() => { load(); }, []);

  return (
    <AppShell title={t("resignation.title")} subtitle={t("resignation.subtitle")}>
      <div className="grid gap-6" data-testid="resignation-page">
        <ResignationForm onDone={load} />
        <RequestStatusList data={{ resignations }} reload={load} />
      </div>
    </AppShell>
  );
}
